<template>
  <div>
    <div :id="id"></div>
  </div>
</template>

<script>
import Vue from 'vue'
import go from 'gojs'
import CommonAnchorButton from '../list/buttonList/CommonAnchorButton.vue'
import VideoViewer from '../video-player/VideoViewer'
import { get } from 'lodash'
import i18n from '../../plugins/i18n'

export default {
  name: 'CustomComponentRenderer',
  components: { CommonAnchorButton, VideoViewer },
  props: {
    namespace: {
      type: String,
    },
    options: {
      type: Object,
      default: () => ({}),
    },
    styles: {
      type: String,
      default: '',
    },
    template: {
      type: String,
      default: '<div>{{ $i18n.t("no_template") }}</div>',
    },
    panelUid: {
      type: String,
      default: '',
    },
  },
  computed: {
    id() {
      return `custom-component-${this.panelUid}`
    },
  },
  methods: {
    get,
    renderComponent() {
      const options = this.options
      options.template = `<div id="${this.id}">${this.template}</div>`

      const Component = Vue.extend({
        ...options,
        components: { CommonAnchorButton, VideoViewer },
        data() {
          const parentData = this.$parent.$data || {}
          const customData = typeof options.data === 'function' ? options.data() : {}

          return {
            ...parentData,
            ...customData,
            CORE: this.$CORE,
            window: window,
            $i18n: this.$i18n,
          }
        },
      })

      const instance = new Component({
        el: `#${this.id}`,
        parent: this,
      })

      instance.$mount(`#${this.id}`)

      const styleElement = document.createElement('style')
      styleElement.textContent = this.styles
      if (instance.$el && instance.$el instanceof Node) {
        instance.$el.appendChild(styleElement)
      } else {
        console.error(this.$i18n.t('template_render_error'))
      }
    },
  },
  mounted() {
    this.renderComponent()
  },
  watch: {
    options: {
      deep: true,
      handler() {
        this.renderComponent()
      },
    },
  },
}
</script>
